import { Chip, Tooltip } from '@mui/material';

interface EstimateChipProps {
  label?: string;
  help: string;
}

export const EstimateChip = ({ label = 'Estimación', help }: EstimateChipProps) => (
  <Tooltip title={help} arrow>
    <Chip
      label={label}
      size="small"
      variant="outlined"
      sx={{ cursor: 'help', height: 20, fontSize: '0.6875rem' }}
    />
  </Tooltip>
);
